import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./RectangularEaseCard.module.scss";

const RectangularEaseCard = ({ title = "Kundalpur", imageUrl }) => {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <div className={styles.cardContainer}>
      <div className={styles.outerCard}>
        <div className={styles.innerCard}>
          <img
            alt={title?.[language || title]}
            src={
              imageUrl ||
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQohQTw7t8k515lP4TzJghRDy-hONJO6zC56A&s"
            }
            loading="lazy"
          />
        </div>
      </div>
      {title && (
        <span className={styles.title}>{title?.[language || title]}</span>
      )}
    </div>
  );
};

export default RectangularEaseCard;
